import { NumberInput, NumberInputProps } from './number-input';
import { forwardRef } from 'react';

export type PriceInputProps = Omit<
  NumberInputProps,
  'thousandSeparator' | 'decimalSeparator' | 'decimalScale' | 'fixedDecimalScale'
>;

export const PriceInput = forwardRef<HTMLInputElement, PriceInputProps>(({ prefix = '£', ...props }, ref) => {
  return (
    <NumberInput
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={2}
      prefix={prefix}
      allowNegative={false}
      ref={ref}
      {...props}
    />
  );
});

PriceInput.displayName = 'PriceInput';
